import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

const Stepper = ({ currentStep }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const bookId = new URLSearchParams(location.search).get("bookId");

    const steps = [
        { name: "Book Details", path: "/create-book" },
        { name: "Cover Selection", path: "/covers" },
        { name: "Upload Manuscript", path: "/upload" },
        { name: "Preview Book", path: "/preview" },
    ];

    const handleStepClick = (index) => {
        const targetStep = index + 1;
        if (bookId && targetStep <= 4) {
            navigate(`${steps[index].path}?bookId=${bookId}`);
        }
    };

    return (
        <div className="w-full py-4 mb-8">
            <div className="flex items-center justify-between relative max-w-3xl mx-auto">
                {/* Connecting Lines */}
                <div className="absolute left-0 right-0 top-5 -translate-y-1/2 h-1 bg-gray-200 -z-10 rounded">
                    <div
                        className="h-full bg-blue-600 transition-all duration-500 rounded"
                        style={{
                            width: `${((currentStep - 1) / (steps.length - 1)) * 100}%`,
                        }}
                    />
                </div>

                {steps.map((step, index) => {
                    const stepNum = index + 1;
                    const isActive = currentStep === stepNum;
                    const isCompleted = currentStep > stepNum;
                    const isClickable = !!bookId;

                    return (
                        <div
                            key={index}
                            onClick={() => isClickable && handleStepClick(index)}
                            className={`flex flex-col items-center flex-1 relative group ${
                                isClickable ? "cursor-pointer" : ""
                            }`}
                        >
                            <div
                                className={`w-10 h-10 rounded-full flex items-center justify-center font-bold border-2 transition-all duration-300 ${
                                    isActive
                                        ? "bg-blue-600 border-blue-600 text-white shadow-md scale-110"
                                        : isCompleted
                                        ? "bg-green-500 border-green-500 text-white hover:bg-green-600"
                                        : "bg-white border-gray-300 text-gray-400"
                                }`}
                            >
                                {isCompleted ? "✓" : stepNum}
                            </div>
                            <span
                                className={`mt-2 text-xs font-semibold text-center transition-colors duration-200 ${
                                    isActive
                                        ? "text-blue-600 font-bold"
                                        : isCompleted
                                        ? "text-green-600"
                                        : "text-gray-400"
                                }`}
                            >
                                {step.name}
                            </span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Stepper;